import { useMobileSitting } from "widgets/mobileIndex/lib/hooks/useMobileSitting"
import { Body } from "../../style"
import { SittingHall } from "../sittingHall";
import { OrderDetail } from "widgets/orderDetail";
import { useOrderInfo } from "entities/orders";

export const MobileIndexSitting = () => {

  const { resourcesForRender, onEndVisitClick, isLoading } = useMobileSitting();
  const { isOpen } = useOrderInfo();

  return (
    <>
    {
      !isOpen ? 
      <Body>
        {
          resourcesForRender.map((resourceForRender, index) => {
            return (
              <SittingHall 
                resource={resourceForRender}
                onEndVisitClick={onEndVisitClick}
                isLoading={isLoading}
                key={index}
              />
            )
          })
        }
      </Body>
      :
      <OrderDetail
        goToBookingBtn={false}
        includeButtons={true}
        maxHeightPanel="calc(100dvh - 147px)"
        heightPanel="calc(100dvh - 147px)"
        includePenButton={false}
        includeContactInfo={true}
        includeCloseButton={true}
        updateOrderInPersonModal={'groupOrders'}
        hideRestore={true}
        closeWhenNotOrder={false}
      />
    }
    </>
  )
}